<template>
  <ui-modal-layout :title="tr('Edit user restrictions')" :icon="UserLockIcon">
    <div class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Visible Brands') }}</ui-label>
      <multi-select
        v-model="visibleBrandIds"
        :options="brands"
        :append-to-body="false"
        value-key="id"
        label-key="name"
      />
    </div>

    <template #footer>
      <ui-button :disabled="isLoading" @click="() => submitForm()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Save') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle, UserLock } from '@lucide/vue';
import { markRaw } from 'vue';

import UserService from '@/services/User.js';
import MultiSelect from '@/ui/components/MultiSelect.vue';

export default {
  name: 'EditUserRestrictionsModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
    MultiSelect,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    newLevel: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    UserLockIcon: markRaw(UserLock),
    isLoading: false,
    visibleBrandIds: [],
  }),
  computed: {
    brands() {
      return this.$root.currentCompany.brands || [];
    },
  },
  created() {
    this.visibleBrandIds = this.user.visible_brand_ids ?? [];
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submitForm() {
      this.$toast.clear();

      if ((this.newLevel === 'restricted_viewer' || this.newLevel === 'restricted_editor') && this.visibleBrandIds.length === 0) {
        this.$toast.error(this.tr('Specifying at least one Brand is required.'));
        return;
      }

      this.isLoading = true;

      const data = {
        level: this.newLevel,
        visibleBrandIds: this.visibleBrandIds,
      };

      UserService.changeLevel(this.user.id, data)
        .then(resp => {
          this.$emit('save', resp);
          this.close();
          this.$toast.success(this.tr('The user\'s access level has been successfully changed.'));
          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isLoading = false);
    },
  },
};
</script>
